import Axios from '@/utils/axios'
import { extractOnlyNumbers } from '@/utils/formatter'
const URL = '/cadastro'

const getCadastroTokenHeaders = () => ({ headers: { 'Cadastro-Token': window.location.pathname.split('/').pop() } })

export default {
  verificaCpf: cpf => {
    return Axios.get(`${URL}/cpf/${cpf}`, getCadastroTokenHeaders())
  },
  buscaEmpresas: busca => Axios.get(`${URL}/empresas`, { params: { busca }, ...getCadastroTokenHeaders() }),
  loadFuncoes: empresaId => {
    return Axios.get(`${URL}/empresas/${empresaId}/funcoes`, getCadastroTokenHeaders())
  },
  loadSetores: empresaId => {
    return Axios.get(`${URL}/empresas/${empresaId}/setores`, getCadastroTokenHeaders())
  },
  buscaHorarios: (data, cpf) => {
    return Axios.get(`${URL}/agenda-medica/${data}/funcionario/${extractOnlyNumbers(cpf)}`, getCadastroTokenHeaders())
  },
  saveFuncionario: cadastro => {
    return Axios.post(`${URL}`, cadastro, getCadastroTokenHeaders())
  }
}
